import { render, staticRenderFns } from "./Text3SectionType.vue?vue&type=template&id=4f100458"
import script from "./Text3SectionType.vue?vue&type=script&lang=js"
export * from "./Text3SectionType.vue?vue&type=script&lang=js"
import style0 from "./Text3SectionType.vue?vue&type=style&index=0&id=4f100458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports